import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: var(--space-200);
  align-items: center;
`

export const DecoratorLabel = styled.div`
  display: flex;
  padding: var(--space-100) var(--space-200);
  border-radius: var(--radius-brand);
  background: var(--bg-alert);
  color: var(--text-alert-tertiary);
  text-transform: uppercase;
  font-size: 10px;
  font-weight: var(--font-weight-semibold);
`
